import React, { useState } from "react"
import { NumericFormat } from 'react-number-format'

interface NumberInputWithCommaProps {
  name: string
  initValue: number | null
  className: string
}

const NumberInputWithComma = ({name, initValue, className}: NumberInputWithCommaProps) => {
  // values.valueがstringのため
  // また、素のinputとNumericFormatで未定義がundefinedとnullと違うため、nullのときは空文字列にする
  const initValueAsString = initValue ? initValue.toString() : ''
  const [value, setValue] = useState(initValueAsString)

  return (
    <>
      {/* バックエンドに送られるのはこちら */}
      <input type="hidden" name={name} value={value} />
      {/* こちらは入力を受け付ける（同期通信的には）fakeなパーツ。labelクリックされたとき対応としてidはこちらに設定 */}
      <NumericFormat 
        value={value} valueIsNumericString={true} 
        onValueChange={(values) => setValue(values.value)} 
        thousandSeparator={true} 
        id={name} className={className} 
      />
    </>
  )
}

export default NumberInputWithComma
